import { AISTATS_LOADING, AISTATS_LIST } from './AiStatsActions';

const INITIAL_STATE = {
  isLoading: true,
  results: undefined,
  page: 0,
  total: 0,
};

const AiStatsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AISTATS_LOADING: {
      return { ...state, isLoading: action.payload || true };
    }
    case AISTATS_LIST:
      return {
        ...state,
        isLoading: false,
        results: action.payload.results,
        page: action.payload.page,
        total: action.payload.total,
      };
    default:
      return { ...state };
  }
};

export default AiStatsReducer;
